import { IsNotEmpty, IsISO8601, IsOptional, IsUUID, IsInt } from 'class-validator';

export class CalendarEventDateChangeDTO {

    @IsNotEmpty()
    @IsISO8601()
    start: string;

    @IsNotEmpty()
    @IsISO8601()
    end: string;

    @IsOptional()
    @IsUUID()
    oldResourceId: string;

    @IsOptional()
    @IsUUID()
    newResourceId: string;

    @IsNotEmpty()
    @IsInt()
    entity: number;

}
